/**
 * Lo que se queda el destino de cada venta. Espejo de
 * `backend/src/services/comision.service.js`.
 *
 * Está duplicado a propósito, igual que `economia`: la pantalla calcula la
 * cuenta mientras escribes un precio, sin ir al servidor a por cada tecla. Los
 * dos archivos tienen que decir lo mismo, y hay una prueba que lo comprueba.
 */

export const COMISION_POR_DESTINO = {
    ebay: { porcentaje: 13, fija: 0.4 },
    shopify: { porcentaje: 2.9, fija: 0.3 },
    woocommerce: { porcentaje: 2.9, fija: 0.3 }
};

function aNumeroONulo(valor) {
    if (valor === null || valor === undefined || valor === '') return null;
    const n = Number(valor);
    return Number.isFinite(n) ? n : null;
}

/**
 * La comisión de un destino. `null` cuando no se sabe cuál es el destino:
 * cero afirmaría que la venta no tiene comisión, y eso no es cierto en ninguno.
 */
export function comisionDe(plataforma, ajustes = null) {
    const guardada = ajustes?.comision;
    const porcentajeGuardado = aNumeroONulo(guardada?.porcentaje);

    if (porcentajeGuardado !== null) {
        return {
            porcentaje: porcentajeGuardado,
            fija: aNumeroONulo(guardada?.fija) ?? 0,
            origen: 'tienda'
        };
    }

    const defecto = COMISION_POR_DESTINO[plataforma];
    if (!defecto) return null;

    return { ...defecto, origen: 'defecto' };
}

export default { comisionDe, COMISION_POR_DESTINO };
